import { Document } from '../../../../models/document.model';

export const QUOTEDEVIL_OVERRIDES: Record<string, Partial<Document>> = {
  'iban': { disabled: true },
  'ncb': { diaryCode: 'A4', disabled: false },
  'mainLicence': { diaryCode: 'A2', disabled: false },
  'aditionalDriver': { diaryCode: 'A3', disabled: false },
  'drivingExperience': { diaryCode: 'A5', disabled: false },
  'gapInCover': { diaryCode: 'A0', disabled: false },
  'proposalForm': { disabled: true },
  'nct': { diaryCode: 'A7', disabled: false },
  'engineerReport': { diaryCode: 'F2', disabled: false },
  'irishRegistration': { diaryCode: 'J2', disabled: false },
  'valuationOfSpecifiedItem': { diaryCode: '54', disabled: false },
  'directDebitMandate': { diaryCode: '', disabled: true },//TO CHECK
  'ppsProof': { diaryCode: 'Z6', disabled: false },
  'identificationProof': { disabled: true },
  'CommercialDDM': { disabled: true },
  'digitalJourney': { disabled: true },
  'certitifateOfIncorporation': { disabled: true },
  'vlc': { diaryCode: 'A8', disabled: false },
  'proofOfBusinessAddress': { disabled: true },
  'taxRegistrationCertificate': { disabled: true },
  'creditWorthinessCheck': { disabled: true },
  'tppEjourneyDiary': { diaryCode: 'CD', disabled: false },
  'premiumCreditManualDocumentation': { disabled: false },
  'premiumCreditEJourney': { disabled: false },
  'proofOfAddress': { disabled: false },
  'marriageCertificate': { diaryCode: '1H', disabled: false },
  'medicalReport': { diaryCode: '18', disabled: false },
  'edt12Lessons': { diaryCode: 'AF', disabled: false },
  'ncbZA': { diaryCode: 'ZA', disabled: false },
  'ncbTransferDeclaration': { diaryCode: 'AA', disabled: false },
};

export const BASE_ONBOARDING_DOCUMENTS: Document[] = [
  {
    "name": "iban",
    "title": "IBAN",
    "diaryCode": "2T",
    "type": "text",
    "value": "",
    "keyValues": [],
    "sequence": 0,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": false,
    "info": "International Bank Account number is required to set up your direct debits.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "It is a current account.",
      "If a joint account only one signature is needed on it.",
      "The insurer is the account holder."
    ]
  },
  {
    "name": "ncb",
    "title": "No Claims Bonus",
    "diaryCode": "2C",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 1,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "Original, Proof of No Claims Bonus. This can be obtained from your previous insurer and will have been included with your renewal documents.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the bonus in the image.",
      "The bonus should be in your name and should note the year of claims free you were quoted on.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "mainLicence",
    "title": "Your Licence",
    "diaryCode": "2E",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 2,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "Copy of your driver's licence, front and back.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the bonus in the image.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "aditionalDriver",
    "title": "Additional Driver",
    "diaryCode": "2F",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 3,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "Copy the named driver's licence, front and back.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the bonus in the image.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "drivingExperience",
    "title": "Letter(s) of Driving Experience",
    "diaryCode": "2D",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 4,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "This can be sourced from your previous insurer(s). We require proof of claims free driving experience to be consecutive and up to date. There can be no gaps between the cover. The letters should include the dates of cover and that no claims were made against the driver while cover was in-force",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the bonus in the image.",
      "The experience should be in your name and should clearly note the years you were covered.",
      "The experience should be consecutive and up to date.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "gapInCover",
    "title": "Gap In Cover Letter",
    "diaryCode": "2I",
    "type": "text",
    "value": "",
    "keyValues": [],
    "sequence": 5,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "It must include the date of cancellation or expiry of your previous policy and confirm that you have not been involved in any accidents or claims since then. The reason for the gap in cover must be stated e.g. car sold, emigration.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": []
  },
  {
    "name": "proposalForm",
    "title": "Proposal Form",
    "diaryCode": "2A",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 6,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "Document to be completed, signed and returned to Chill. This document will have been included with your initial insurance pack we sent to you.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the bonus in the image.",
      "All parts of the form are filled out and that the information is correct.",
      "The form is signed and dated.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "nct",
    "title": "NCT Certificate",
    "diaryCode": "2J",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 7,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "An image of the NCT to show that the car is road worthy.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the bonus in the image.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "engineerReport",
    "title": "Engineers Report",
    "diaryCode": "2L",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 8,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "An image to show that the car is road worthy or that repairs have been carried out.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the bonus in the image.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "irishRegistration",
    "title": "Irish Registration",
    "diaryCode": "2N",
    "type": "text",
    "value": "",
    "keyValues": [],
    "sequence": 9,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "If a car has been imported we need the Irish registration number once it has been provided to you.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": []
  },
  {
    "name": "valuationOfSpecifiedItem",
    "title": "Valuation of Specified Item(s)",
    "diaryCode": "2H",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 10,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "A copy of a valuation showing a description of the specified item(s) item and the value.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the bonus in the image.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "directDebitMandate",
    "diaryCode": "2B",
    "type": "file",
    "value": "",
    "keyValues": [],
    "title": "Direct Debit Mandate",
    "sequence": 10,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "Document to be completed, signed and returned to Chill in order to set up your direct debits. This document will have been included with your initial insurance pack we sent to you.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the bonus in the image.",
      "Only the policy holder is required to sign under the heading “Signature of Customer”.",
      "The 'Signature of Bank' section must be left blank.",
      "The mandate itself must be completed and signed by the person whose bank details are provided.",
      "If the account is in one name only, please print that person’s name in the first “Your Name” box and ask them to sign in the “Signature(s)” space.",
      "If the account is a joint account, please ensure both names are printed, in the sections marked “Your Name(s)” and signed by both account holders in the “Signature(s)” space.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "ppsProof",
    "title": "Proof of PPS",
    "diaryCode": "2O",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 10,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "We can accept a photo or scan of a Payslip, Tax credit statement or Medical Card.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the bonus in the image.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "identificationProof",
    "title": "Proof of Identification",
    "diaryCode": "2P",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 10,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "Driving license, passport or government ID",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the bonus in the image.",
      "The bonus should be in your name and should note the year of claims free you were quoted on.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "CommercialDDM",
    "title": "Commercial DDM",
    "diaryCode": "9C",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 11,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "We need a photo or scan of the direct debt mandate we have sent you. You will need to print, sign and date the document before returning",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the document in the image.",
      "Only the policy holder is required to sign under the heading “Signature of Customer”.",
      "The \"Signature of Bank\" section must be left blank.",
      "The mandate itself must be completed and signed by the person whose bank details are provided.",
      "If the account is in one name only, please print that person’s name in the first “Your Name” box and ask them to sign in the “Signature(s)” space.",
      "If the account is a joint account, please ensure both names are printed, in the sections marked “Your Name(s)” and signed by both account holders in the “Signature(s)” space.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "digitalJourney",
    "title": "Digital Journey",
    "diaryCode": "2S",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 12,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "Finance application",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "Your finance provider has sent you an email and text message, please follow the link included to complete your finance application."
    ]
  },
  {
    "name": "certitifateOfIncorporation",
    "title": "Certificate Of Incorporation",
    "diaryCode": "2U",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 13,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "A document showing that the business has been registered",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the document in the image.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "vlc",
    "title": "VLC",
    "diaryCode": "2K",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 14,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "Copy of the Vehicle Licensing Certificate confirming you are the registered owner",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the document in the image.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "proofOfBusinessAddress",
    "title": "Proof Of Business Address",
    "diaryCode": "2Q",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 15,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "Provide a copy of ONE of the following documents addressed to the business dated within 6 months. Utility or landline telephone bill; Statement from a Bank, Building Society or Credit Union; Correspondence from the Revenue or Department of Employment Affairs. Correspondence from an insurance company in respect of an insurance policy currently in force",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out the name and address cleary.",
      "We can see all four corners of the document in the image.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "taxRegistrationCertificate",
    "title": "Tax Registration Certificate",
    "diaryCode": "2V",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 16,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "Copy of Tax Registration Certificate as issued by Revenue",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the document in the image.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "creditWorthinessCheck",
    "title": "Credit Worthiness Check",
    "diaryCode": "2R",
    "type": "file",
    "value": "",
    "keyValues": [],
    "sequence": 17,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "This is a supplementary document to your Finance Agreement.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": []
  },
  {
    "name": "tppEjourneyDiary",
    "title": "Third Party Payer E-Journey",
    "diaryCode": "2G",
    "type": "text",
    "value": "",
    "keyValues": [],
    "sequence": 18,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": false,
    "info": "Supplementary document for finance agreement.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "The account holder will need to confirm their bank account via the app and upload Proof of Address and Proof of ID.",
      "The policy holder will need to complete the full application journey."
    ]
  },
  {
    "name": "premiumCreditManualDocumentation",
    "title": "Premium Credit Manual Documentation",
    "diaryCode": "21",
    "type": "file",
    "disabled": true,
    "value": "",
    "keyValues": [],
    "sequence": 19,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "Pages 6, 7 and 8 to be completed, signed and returned to Quote Devil in order to set up your direct debits. This document will have been included with your initial insurance pack we sent to you. Please note that we will also require Photo ID, Proof of Address, proof of PPSN (if your agreement exceeds €500), and a \"selfie\" image of you to allow Premium Credit to verify identity.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the credit agreement, \"Know Your Customer\" and direct debit mandate in the image.",
      "The mandate itself must be completed and signed by the person whose bank details are provided.",
      "If the account is in one name only, please print that person’s name in the first \"Your Name\" box and ask them to sign in the \"Signature(s)\" space.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "premiumCreditEJourney",
    "title": "Premium Credit eJourney",
    "diaryCode": "CE",
    "type": "file",
    "disabled": true,
    "value": "",
    "keyValues": [],
    "sequence": 20,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": false,
    "info": "This email and message will contain a link and access code to download the finance app. Please go to your APP store and download the premium credit application, and once downloaded please enter your access code and date of birth. You will need to enter your IBAN and BIC and agree to the terms of the finance agreement. You will then need to take a selfie and upload in date proof of identification, proof of address in the last 6 months and proof of PPSN. ",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "Your finance provider has sent you an email and text message, please follow the link included to complete your finance application."
    ]
  },
  {
    "name": "proofOfAddress",
    "title": "Proof Of Address",
    "diaryCode": "CF",
    "type": "file",
    "disabled": true,
    "value": "",
    "keyValues": [],
    "sequence": 21,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "Provide a copy of ONE of the following documents addressed to the business dated within 6 months. Utility or landline telephone bill; Statement from a Bank, Building Society or Credit Union; Correspondence from the Revenue or Department of Employment Affairs. Correspondence from an insurance company in respect of an insurance policy currently in force",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out the name and address cleary.",
      "We can see all four corners of the document in the image.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
    {
    "name": "marriageCertificate",
    "title": "Marriage Certificate",
    "diaryCode": "1H",
    "type": "file",
    "disabled": true,
    "value": "",
    "keyValues": [],
    "sequence": 22,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "We can accept a photo or scan of your Marriage Certificate. This is to verify your name, as there is a discrepancy between your ID and your credit agreement with Premium Credit.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the document in the image.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "medicalReport",
    "title": "Doctor's letter / Medical report to confirm that you are fit to drive.",
    "diaryCode": "18",
    "type": "file",
    "disabled": true,
    "value": "",
    "keyValues": [],
    "sequence": 23,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "This is to show that you have a medical condition, and confirms that you are fit to drive despite this condition.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "This must be obtained from a GP or relevant doctor.",
      "This must confirm that you are fit to drive.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "edt12Lessons",
    "title": "Proof of 12 EDT Lessons being completed",
    "diaryCode": "AF",
    "type": "file",
    "disabled": true,
    "value": "",
    "keyValues": [],
    "sequence": 24,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "This is to show that you have completed all 12 EDT Lessons, and can be obtained by either uploading your Lesson Log Book, or can be a screenshot taken from your myRSA portal, showing all 12 lessons are complete.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all 12 lessons clearly",
      "The lessons should be in your name and should note the date and lesson type, for each one.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
 {
    "name": "ncbZA",
    "title": "Mirrored No Claims Bonus",
    "diaryCode": "ZA",
    "type": "file",
    "disabled": true,
    "value": "",
    "keyValues": [],
    "sequence": 25,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "Original, \"Live\" Proof of No Claims Bonus. This can be obtained from your current insurer and will show that you have an active policy with no claims.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "We can make out all of the information.",
      "We can see all four corners of the bonus in the image",
      "The bonus should be in your name and should note the year of claims free you were quoted on.",
      "Only files with pdf, jpeg, jpg and png extensions are accepted."
    ]
  },
  {
    "name": "ncbTransferDeclaration",
    "title": "NCB Transfer Declaration",
    "diaryCode": "AA",
    "type": "text",
    "value": "",
    "keyValues": [],
    "sequence": 26,
    "expanded": false,
    "isSubmitted": false,
    "enableSubmitButton": false,
    "enableUploadButton": true,
    "info": "It must include confirmation that you are happy to move your no claims bonus from the old vehicle to the new one, and confirm that you are not using your No Claims Bonus on another vehicle at this time.",
    "uploadProgress": 0,
    "files": [],
    "diary": null,
    "errorMessage": null,
    "responseStatusText": null,
    "instructions": [
      "The vehicle registration on your No Claims Bonus has been sold / no longer in use by yourself.",
      "You are not using this No Claims Bonus on another vehicle.",
      "You are happy to transfer your No Claims Bonus to the vehicle on cover with Quote Devil."
    ]
  },
];
